module.exports = __webpack_public_path__ + "ceneo.png?440451dc27db3821813f3d784eb7d9ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ceneo.png
// module id = 178
// module chunks = 2